export const Select: React.FC<
  React.HTMLAttributes<HTMLSelectElement> & {
    options?: ({ label: string; value: string } | [string, string] | string)[];
    blankOption?: string;
  }
> = ({ options, blankOption, ...htmlAttrs }) => (
  <select
    className='pl-3 pr-12 py-2 w-80 bg-down-bracket bg-right bg-no-repeat border border-gray-ccc rounded-md appearance-none'
    style={{
      backgroundSize: '1.5rem',
      backgroundPosition: 'top 50% right 0.75rem',
    }}
    {...htmlAttrs}
  >
    {blankOption && <option value={''}>{blankOption}</option>}
    {options?.map((option, i) => (
      <option
        key={i}
        value={
          typeof option === 'string'
            ? option
            : Array.isArray(option)
            ? option[0]
            : option.value
        }
      >
        {typeof option === 'string'
          ? option
          : Array.isArray(option)
          ? option[1]
          : option.label}
      </option>
    ))}
  </select>
);
